import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, CalendarDays } from "lucide-react";
import { PoweredBy } from "@/components/PoweredBy";
import { AddToCalendar } from "@/components/AddToCalendar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Calendario() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const load = () => axios.get(`${API}/portal/${token}/calendar`).then(({ data }) => setData(data)).catch(() => setErr(true));
  useEffect(() => { load(); }, [token]);
  const added = (reload = true) => axios.post(`${API}/portal/${token}/calendar/added`).then(() => reload && load());

  if (err) return <div className="min-h-screen grid place-items-center text-slate-500 p-6" data-testid="cal-not-found">Ligação inválida ou expirada.</div>;
  if (!data) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-slate-400" /></div>;

  return (
    <div className="min-h-screen bg-slate-50 px-5 py-10 font-body" data-testid="calendario-page">
      <div className="max-w-md mx-auto space-y-6">
        <div className="pb-3 border-b-2" style={{ borderColor: data.color }}>{data.logo ? <img src={data.logo} alt={data.agency_name} className="h-10" /> : <div className="font-semibold text-lg text-ec-green">{data.agency_name}</div>}</div>
        <div className="rounded-2xl p-5 text-white bg-ec-green">
          <div className="text-sm opacity-80">{data.property_address}</div>
          <div className="flex items-center gap-2 text-2xl font-medium mt-2" data-testid="cal-deed-date">
            <CalendarDays size={22} /> {data.deed_date ? `Escritura a ${data.deed_date}` : "Data da escritura a confirmar"}
          </div>
        </div>
        {data.calendar ? (
          <div className="bg-white rounded-2xl p-5 border border-slate-100">
            <AddToCalendar cal={data.calendar} icsHref={`${API}/portal/${token}/calendar.ics`} onAdded={added} testid="cal" />
            <p className="text-xs text-slate-400 mt-3">A hora e o local são confirmados pelo seu consultor.</p>
          </div>
        ) : <p className="text-sm text-slate-500">Ainda não há data marcada. Avisamos assim que estiver confirmada.</p>}
        {data.powered !== false && <p className="text-center"><PoweredBy testid="cal-powered-by" /></p>}
      </div>
    </div>
  );
}
